/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// component
import EmbedAnalytics from 'pages/dashboard/embeds/analytics/embed_analytics';



/* ========== ~~~~~~~~~~ EMBED ANALYTICS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    isDataReceived: embedsState.embedsStatus.isDataReceived,
});

// map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    // mapDispatchToProps
)(EmbedAnalytics));
